import React from 'react'
import cx from 'classnames'
import {
  useIsTrackSwitchedOff,
  usePublications,
  useTrack,
  useParticipantIsReconnecting,
  useIsTrackEnabled
} from '@gopeerproject/web-kit'

import { User, Icon, Loader } from '@components/UI'

import NetworkQualityLevel from './NetworkQualityLevel'
import { useClassroomQuery } from '../../../hooks'

const ParticipantInfo = ({
  children,
  participant,
  isSelected,
  onClick,
  isLocalParticipant,
  hideParticipant
}) => {
  const { data } = useClassroomQuery()
  const { image, name } = {
    image: data?.participants[participant?.identity]?.image,
    name: data?.participants[participant?.identity]?.name
  }

  const publications = usePublications(participant)
  const audioPublication = publications.find((p) => p.kind === 'audio')
  const videoPublication = publications.find((p) =>
    p.trackName.includes('camera')
  )

  const isVideoEnabled = !!videoPublication
  const isScreenShareEnabled = publications.find((p) =>
    p.trackName.includes('screen')
  )

  const videoTrack = useTrack(videoPublication)
  const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack)

  const audioTrack = useTrack(audioPublication)
  const isParticipantReconnecting = useParticipantIsReconnecting(participant)
  const isAudioTrackEnabled = useIsTrackEnabled(audioTrack)

  return (
    <div
      className={cx('gp-Media-participantInfo', {
        'is-hidden': hideParticipant,
        'is-local': isLocalParticipant,
        'is-videoOff': !isVideoEnabled || isVideoSwitchedOff,
        'is-selected': isSelected,
        // TODO get rid of this once we figure out what's up with avatar
        // and video showing up at the same time
        'is-videoEnabled': isVideoEnabled,
        'is-videoSwitchedOff': isVideoSwitchedOff
      })}
      onClick={onClick}
    >
      <div className='gp-Media-participantInfo-video'>
        {children}
        {(!isVideoEnabled || isVideoSwitchedOff) && (
          <User name={name} img={image} hideName size='larger' />
        )}
        {isParticipantReconnecting && <Loader icon full withBackground />}
      </div>

      {isSelected && (
        <div className='gp-Media-participantInfo-pin'>
          <Icon name='stick outline' />
        </div>
      )}
      <div className='gp-Media-participantInfo-info'>
        <div>
          {isAudioTrackEnabled ? (
            <Icon name='microphone' />
          ) : (
            <Icon name='microphone off' />
          )}
        </div>
        {isScreenShareEnabled && (
          <div>
            <Icon name='screen' />
          </div>
        )}
        <NetworkQualityLevel participant={participant} />
      </div>
    </div>
  )
}

export default ParticipantInfo
